import BaseView from "./_BaseView";
import LineGraph from "../graphs/LineGraph";
import Table from "../components/Table";
import Confirm from "../components/Confirm";
import Api from "../Api";
import Notify from "../components/Notify";
import Treemap from "../graphs/Treemap.js";
import TabLoad from "../components/TabLoad.js";
import StackedBarChart from "../graphs/StackedBarChart.js";

export default class AnalyticsUserView extends BaseView {

    init() {
        super.init();

        const self = this;

        TabLoad('#userDetailActivity', () => {
            LineGraph({
                container: '#userDetailActivity',
                svg: '.user-activity',
                counter: 'steps',
                yLabel: Lang.userDetailActivityyLabel
            });
        });
        TabLoad('#monthlyStarts-user', () => {
            StackedBarChart({
               container: '#monthlyStarts-user',
               svg: '#monthlyStarts-user .monthly-starts',
               bar1label: Lang.started,
               bar2label: Lang.completed,
               link: `/app/${$('[data-app]').data('app')}/jumps`,
               param: 'month'
            });
        });
        // const graph = $('#userDetailActivity');
        // if (graph.length > 0) {
        //     LineGraph({
        //         container: '#userDetailActivity',
        //         svg: '.user-activity',
        //         counter: 'steps',
        //         yLabel: Lang.userDetailActivityyLabel
        //     });
        // }

        if($('.top-users-treemap').length > 0) {
            const url = $(this).data('url');
            Treemap({
                container: '.top-users-treemap',
                svg: '.top-users-svg'
            });
        }

        const userid = $('#userAnalyticsView').data('id');
        if (userid !== undefined) {
            this.guideTable = new Table('userGuides', `/api/guides/user_table?userid=${userid}`, [
                {data: 'title', orderable: true},
                {data: 'active'},
                {data: 'started'},
                {data: 'completed'},
                {data: 'progress', orderable: true},
            ]);
            this.pathwayTable = new Table('userPathways', `/api/pathway/user_table?userid=${userid}`, [
                {data: 'title', orderable: true},
                {data: 'description'},
                {data: 'guides'},
            ]);
        }

        if ($('#assignedGuides').length > 0) {
            this.assignedTable = new Table('assignedGuides', `/api/guides/assigned_table?userid=${userid}`, [
                {data: 'title', orderable: true},
                {data: 'progress'},
                {data: 'tools', orderable: false}
            ]);

            $('#assignedGuides').on('click', '.delete', function () {
                const id = $(this).parents('div:eq(0)').data('id');
                Confirm({
                    ok: Lang.remove,
                    title: Lang.remove,
                    msg: Lang.remsure,
                    onConfirm: () => {
                        Api.send(`/api/users/${userid}/unassign`, { guideid: id}, 'post').done(() => {
                            self.assignedTable.reload();
                        });
                    }
                });
            });
        }

        $('#menuAssignedGuides .add-guide').on('click', () => {
            // repurpose roleguide-form
            Api.getTpl('roleguide-form').done(r => {
                Api.send('/api/guides', {application_id: $('[data-app]').data('app')}).done(guides => {
                    const tpl = _.template(r);
                    Confirm({
                        ok: Lang.save,
                        title: Lang.aguides,
                        msg: tpl({guides: guides}),
                        onConfirm: () => {
                            const data = $('form').aeroSerialize();
                            data.guides = data.guideid;
                            data.users = [userid];
                            Api.send('/api/users/assign', data, 'post').done(() => {
                                this.assignedTable.reload();
                            });
                        }
                    });
                });
            });
        });

        $('#clearHistory').on('click', () => {
            Confirm({
                ok: 'Clear',
                title: 'Clear Guide History',
                msg: 'Are you sure you want to clear guide activity? This cannot be undone.',
                onConfirm: () => {
                    Api.send(`/api/users/${userid}/clearhistory`, { }, 'post').done(() => {
                        window.location.reload();
                    });
                }
            });
            return false;
        });
    }
}